import {
  Button,
  Container,
  Paper,
  PasswordInput,
  TextInput,
  Title,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useLoginMutation } from '@/modules/auth';
import { handleLoginError } from '@/modules/auth/utils/helpers/login-errors';
import { showError } from '@/shared';

import classes from './login.module.css';

import type { TLoginRequest } from '@/modules/auth';

type FormData = TLoginRequest;
type Props = {
  isAuth: boolean;
};

export const Login = ({ isAuth }: Props) => {
  const navigate = useNavigate();
  const [login, { isLoading, error }] = useLoginMutation();
  const loginError = handleLoginError(error);

  useEffect(() => {
    if (isAuth) {
      navigate('/');
    }
  }, [navigate, isAuth]);

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {
      login: '',
      password: '',
    },
    validate: {
      login: (value) =>
        value.length < 2 ? 'Введите логин' : null,
      password: (value) =>
        value.length < 2 ? 'Введите пароль' : null,
    },
  });

  useEffect(() => {
    const errorText = loginError?.login || loginError?.root;
    if (errorText) {
      showError({ message: errorText });
    }
  }, [loginError?.login, loginError?.root])

  const handleSubmit = async (values: FormData) => {
    await login(values);
  };

  return (
    <Container size={420} my={40}>
      <Title ta="center" className={classes.title}>
        Вход
      </Title>

      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Paper withBorder shadow="md" p={30} mt={30} radius="md">
          <TextInput
            label="Логин"
            placeholder="login"
            withAsterisk
            key={form.key('login')}
            {...form.getInputProps('login')}
          />
          <PasswordInput
            label="Пароль"
            placeholder="Password"
            withAsterisk
            mt="md"
            key={form.key('password')}
            {...form.getInputProps('password')}
          />
          <Button
            fullWidth
            mt="xl"
            type="submit"
            loading={isLoading}
          >
            Войти
          </Button>
        </Paper>
      </form>

    </Container>
  );
}
